<div
  style="z-index: 2; position: fixed; width: 100%; top: 60px"
  *ngIf="subscriptions.length > 0"
>
  <p
    class="alert m-0"
    role="alert"
    *ngFor="let item of subscriptions; let i = index"
    [ngClass]="{
      'alert-warning': item.status == 0,
      'alert-danger': item.status == 2
    }"
  >
    <span *ngIf="item.status == 0">
      Payment Process for {{ getPlanType(item.plan.planType) }}
      <strong> ({{ item.plan.planName }}) </strong>: We are waiting for your
      License payment, please send us the deposit slip via email
      <strong>(accounts@splendidaccounts.com)</strong> or WhatsApp
      <strong>(03277019212 | 03394155710)</strong>.</span
    >
    <span *ngIf="item.status == 2">
      {{ getPlanType(item.plan.planType) }}
      <strong> ({{ item.plan.planName }}) </strong> Expired : Please renew your
      license to continue!</span
    >
    <button
      *ngIf="item.plan.planType == 1"
      type="button"
      class="close"
      (click)="closeAlert(i)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </p>
</div>

<nav
  class="navbar fixed-top flex-nowrap"
  style="padding: 1.5rem 0 1.5rem 0 !important; align-content: center"
>
  <div class="d-flex align-items-center">
    <a
      (click)="
        menuButtonClick(
          $event,
          sidebar.menuClickCount,
          sidebar.containerClassnames
        );
        (false)
      "
      href="javascript:;"
      class="menu-button d-none d-md-block"
    >
      <svg class="main" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 17">
        <rect x="0.48" y="0.5" width="7" height="1" />
        <rect x="0.48" y="7.5" width="7" height="1" />
        <rect x="0.48" y="15.5" width="7" height="1" />
      </svg>
      {{ " " }}
      <svg class="sub" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 17">
        <rect x="1.56" y="0.5" width="16" height="1" />
        <rect x="1.56" y="7.5" width="16" height="1" />
        <rect x="1.56" y="15.5" width="16" height="1" />
      </svg>
    </a>

    <a
      (click)="mobileMenuButtonClick($event, sidebar.containerClassnames)"
      href="javascript:;"
      class="menu-button-mobile d-xs-block d-sm-block d-md-none"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 17">
        <rect x="0.5" y="0.5" width="25" height="1" />
        <rect x="0.5" y="7.5" width="25" height="1" />
        <rect x="0.5" y="15.5" width="25" height="1" />
      </svg>
    </a>
  </div>
  <div class="row flex-grow-1 align-items-center px-2">
    <div class="col-4 d-flex flex-wrap">
      <p class="font-weight-bold m-0 mr-2" style="font-size: 17px">
        Consignments: &nbsp;<b class="badge badge-success"
          >{{ subscriptionsUsage?.orders | number:'1.0':'en-US' }} /
          {{ subscriptionsUsage?.allocatedOrders | number:'1.0':'en-US' }}</b
        >
      </p>

      <p class="font-weight-bold m-0 marginTop2px" style="font-size: 17px">
        Expiry: &nbsp;<b class="badge badge-danger">{{
          subscriptionsUsage?.expiryDate
        }}</b>
      </p>
    </div>
    <!-- Shipkardo logo -->
    <div class="col-4 text-center">
      <img
        id="logo-img"
        src="../../../../assets/logos/destination/logo.png"
        height="height: 57px;"
        alt="company logo"
      />
    </div>

    <div class="col-4 text-right" id="right-navbar">
      <div class="header-icons d-inline-block align-middle">
        <div
          class="position-relative d-inline-block"
          style="margin-top: 0.5rem !important"
        >
          <div dropdown>
            <button
              id="button-basic"
              dropdownToggle
              type="button"
              id="notificationButton"
              class="header-icon btn btn-empty"
            >
              <i id="bell-icon" class="simple-icon-bell"></i>
              <span class="count" *ngIf="notificationCount > 0">{{
                notificationCount > 99 ? "99+" : notificationCount
              }}</span>
            </button>
            <div
              id="dropdown-basic"
              *dropdownMenu
              class="dropdown-menu dropdown-menu-right mt-3"
              id="notificationDropdown"
            >
              <div *ngIf="notificationsArray.length == 0" class="text-center">
                <p style="font-weight: 700">NO NOTIFICATION YET!</p>
                <p>When you get notifcations, They'll show up here.</p>
                <span class="fa fa-bell fa-3x text-muted"></span>
              </div>

              <perfect-scrollbar
                class="scroll"
                [config]="{ suppressScrollX: true, wheelPropagation: false }"
                style="max-height: 230px"
                class="mb-2"
              >
                <div
                  *ngFor="let not of notificationsArray"
                  class="d-flex flex-row mb-2 pb-2 border-bottom"
                >
                  <a href="javascript:;">
                    <h3>
                      <span class="badge badge-primary">{{
                        not.typeId == 0 ? "O" : not.typeId == 1 ? "L" : "W"
                      }}</span>
                    </h3>
                  </a>
                  <div class="pl-3">
                    <a href="javascript:;">
                      <p class="font-weight-medium mb-1">{{ not.stxt }}</p>
                    </a>
                  </div>
                </div>
              </perfect-scrollbar>

              <div *ngIf="notificationsArray.length > 0" class="text-center">
                <button
                  (click)="markNotificationsAsRead()"
                  class="badge badge-success d-inline text-small w-100"
                >
                  Mark all as read
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="header-icons d-inline-block align-middle">
        <div class="position-relative d-inline-block">
          <div dropdown>
            <button class="btn btn-empty p-0" type="button" dropdownToggle>
              <span id="company-span" class="name">{{
                selectedCompany?.name
              }}</span>
              <span>
                <img id="profile-img" alt="Company Logo" [src]="companyLogo" />
              </span>
            </button>
            <div
              *dropdownMenu
              class="dropdown-menu dropdown-menu-right mt-3"
              id="notificationsDropdown"
            >
              <perfect-scrollbar *ngIf="isSeeMore">
                <div id="company-name">
                
                  <a
                    *ngFor="let item of companiesToDisplay"
                    class="dropdown-item dropdown-item-company c-pointer"
                    (click)="activateCompany(item)"
                  >
                    {{ item.name }}
                  </a>
                  
                </div>
              </perfect-scrollbar>
                <div id="company-name-hide" *ngIf="!isSeeMore">
                  <a
                    *ngFor="let item of companiesToDisplay"
                    class="dropdown-item dropdown-item-company c-pointer"
                    (click)="activateCompany(item)"
                  >
                    {{ item.name }}
                  </a>
                </div>
                <div id="options">
                  <a
                    id="see-more"
                    class="dropdown-item c-pointer text-right text-primary"
                    *ngIf="moreCompany"
                    (click)="clickSeeMore(); $event.stopPropagation()"
                    >See More</a
                  >
                  <a
                    class="dropdown-item c-pointer text-right text-primary"
                    *ngIf="isSeeMore"
                    (click)="clickHide(); $event.stopPropagation()"
                    >Hide</a
                  >
                  <li
                    *ngIf="filteredUserCompanies?.length > 0"
                    class="divider dropdown-divider"
                  ></li>
                  <a
                    class="dropdown-item c-pointer"
                    (click)="topNav('AddCompany')"
                    >Add Company</a
                  >
                  <!-- <a class="dropdown-item c-pointer" (click)="topNav('CompanySetting')">Company Settings</a> -->
                  <a
                    class="dropdown-item c-pointer"
                    (click)="topNav('Subscription')"
                    >Subscriptions</a
                  >
                  <a
                    class="dropdown-item c-pointer"
                    (click)="topNav('UserProfile')"
                    >User Profile</a
                  >
                  <a
                    class="dropdown-item c-pointer"
                    (click)="topNav('ChangePassword')"
                    >Change Password</a
                  >
                  <li class="divider dropdown-divider"></li>
                  <a class="dropdown-item c-pointer" (click)="onSignOut()">
                    Sign out
                  </a>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</nav>
